import React from 'react'
import { Link } from 'react-router-dom'
import { Screen } from '../../components/lease/Screen'
import { BrandHeading } from '../../components/lease/BrandHeading'

// Ported from the LeaseWise-Frontend mockup "5b Refund Policy.png" (support
// email normalized to the coloradoleasecheck.com domain).
// PENDING TEZ LEGAL REVIEW — tracked in active-tasks.
function RefundPolicy() {
  return (
    <Screen className="max-w-2xl">
      <header className="animate-fade-in text-center">
        <BrandHeading className="text-4xl">Refund Policy</BrandHeading>
      </header>

      <div className="mt-6 animate-slide-in space-y-6 rounded-2xl bg-white/70 p-5 shadow-sm ring-1 ring-emerald-100 backdrop-blur dark:bg-slate-800/60 dark:ring-slate-700">
        <p className="text-center text-slate-700 dark:text-slate-200">
          At LeaseCheck, we are committed to providing the best service to our users. This
          refund policy outlines the conditions under which refunds can be claimed.
        </p>

        <section>
          <h2 className="text-xl font-semibold text-slate-800 dark:text-slate-100">Eligibility for Refunds</h2>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">Refunds are granted under the following conditions:</p>
          <ul className="mt-2 list-disc pl-6 text-sm text-slate-600 dark:text-slate-300">
            <li>The service was not delivered as promised.</li>
            <li>Technical issues prevented the use of our service.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-slate-800 dark:text-slate-100">Procedure to Claim a Refund</h2>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">To claim a refund, please follow these steps:</p>
          <ul className="mt-2 list-disc pl-6 text-sm text-slate-600 dark:text-slate-300">
            <li>
              Contact our support team at{' '}
              <a className="text-emerald-700 underline dark:text-emerald-400" href="mailto:support@coloradoleasecheck.com">
                support@coloradoleasecheck.com
              </a>
              .
            </li>
            <li>Provide your order number and reason for the refund.</li>
            <li>Our team will review your request and respond within 3–5 business days.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-slate-800 dark:text-slate-100">Contact Information</h2>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
            For any questions regarding our refund policy, please contact us at{' '}
            <a className="text-emerald-700 underline dark:text-emerald-400" href="mailto:support@coloradoleasecheck.com">
              support@coloradoleasecheck.com
            </a>
            .
          </p>
        </section>
      </div>

      <div className="mt-8 animate-slide-in text-center">
        <Link
          to="/legal"
          className="inline-block w-full transform rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 py-4 text-lg font-bold text-white shadow-lg transition hover:-translate-y-0.5 hover:from-emerald-700 hover:to-teal-700 hover:shadow-xl"
        >
          Return to Legal Stuff
        </Link>
      </div>
    </Screen>
  )
}

export default RefundPolicy
